module.exports = __webpack_public_path__ + "static/megapolo-sabado-5ca410e8f995f007dd69dfc1b2ec8c3e.jpg";